
// controls a bunch of sounds under one id.

class AudioChannel {
    constructor(channelID, soundIds, player) {
        this.channelID = channelID;
        this.soundIds = soundIds;
        this.player = player;
    }
    play() {
        this.soundIds.forEach(id => this.player.play(id, { multiple: false }));

        setTimeout(() => {
            
            if(!this.soundIds.some(id => this.player.playing(id))) {
                app.radio.$emit("audio-controller-audio-allowed-to-start-false")
            }else {
                app.radio.$emit("audio-controller-audio-allowed-to-start-true")
            }

            
        }, 1500)
    }
    pause() { 
        this.soundIds.forEach(id => this.player.pause(id))
    }
    mute(value, time=0) {
        value ? this.fade(0, time) : this.fadeIn(time);
    }
    fade(volume, time, onFade = null) {
        this.soundIds.forEach(id => this.player.fade(id, {volume, time}))
        setTimeout(()=> {
            onFade && onFade();
        }, time)
    }
    fadeIn(time, onFade) {
        this.soundIds.forEach(id => {
            const initialVolume = this.player.getSoundById(id).options.volume
            this.player.fade(id, {volume: initialVolume, time})
        })
        setTimeout(()=> {
            onFade && onFade();
        }, time)
    }
    stop () {
        this.soundIds.forEach(id => this.player.stop(id))
    }
}